import React from 'react';

const DonationsContext = React.createContext({
    donations: [],
    setDonations: () => { }
})

export default DonationsContext;